import useIntersectionObserver from "../../hooks/useIntersectionObserver";
import styles from "./ColorBanner.module.css";

function ColorBanner({
    color = "var(--keel-navy)",
    linkText = "Contact us",
    linkHref = "/contact-us",
    heading = "Let's build the future of mental health together",
    headingStyle = {},
    linkStyle = {},
    hideLink = false,
}) {
    const [ref, , fadedClassName] = useIntersectionObserver(0.2);
    return (
        <section
            className={styles.color_banner}
            style={{ backgroundColor: color }}
            ref={ref}
        >
            <h1 style={headingStyle} className={fadedClassName}>
                {heading}
            </h1>
            {!hideLink && (
                <a
                    className={[
                        "orange-button",
                        styles.link_button,
                        fadedClassName,
                    ].join(" ")}
                    href={linkHref}
                    style={linkStyle}
                >
                    {linkText}
                </a>
            )}
        </section>
    );
}

export default ColorBanner;
